import React from "react";

import LockIcon from "@material-ui/icons/Lock";

import { FormLabel, Typography } from "@material-ui/core";

import TrimmedText from "components/TrimmedText";

import {
  MultiValueContainer,
  MultiValues,
  MultiValue,
} from "components/Input/Dropdown/styles";

import { Container, LabelContainer, ViewContainer } from "./styles";

type Props = {
  label?: string;
  value?: any;
  linesCount?: number;
  isRichText?: boolean;
};

const SimpleField = ({ label, value, linesCount, isRichText }: Props) => {
  const data = Array.isArray(value)
    ? value.length
      ? value
      : "-"
    : value || "-";

  return (
    <Container>
      {label && (
        <LabelContainer>
          <FormLabel>{label}</FormLabel>
        </LabelContainer>
      )}

      {!isRichText ? (
        Array.isArray(data) ? (
          <MultiValueContainer>
            <MultiValues>
              {data.map(item => (
                <MultiValue key={item.id} hideClearIcon>
                  <Typography variant="subtitle1">
                    {item?.name ?? "-"}
                  </Typography>
                  {item?.switchState && <LockIcon />}
                </MultiValue>
              ))}
            </MultiValues>
          </MultiValueContainer>
        ) : (
          <TrimmedText lines={linesCount ?? 1} text={value}>
            <Typography variant="subtitle1">{data}</Typography>
          </TrimmedText>
        )
      ) : (
        <ViewContainer
          dangerouslySetInnerHTML={{
            __html: value,
          }}
        />
      )}
    </Container>
  );
};

export default SimpleField;
